import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { PaginationWithoutCacheProps } from './interface';
import useBusinessLogic from './useBusinessLogic';

const PaginationWithoutCache: React.FC<PaginationWithoutCacheProps> = (props) => {
  const {
    showPrevPageButton,
    showNextPageButton,
    isShowComponent,
    summaryLabel,
    visiblePages,
    handleClickPrevButton,
    handleClickNextButton,
  } = useBusinessLogic(props);
  // 0件の場合は何も表示しない
  if (!isShowComponent) return <></>;

  return (
    <div className={classNames('uc-pagination-wrapper u-flex', 'u-justify-end')}>
      <div className='uc-pagination-help u-text-m u-mr16' data-testid='searchResult' data-testid-e2e='Pagination-selectcount-result'>
        {summaryLabel}
      </div>

      <ul className='uc-pagination' data-testid='pagingList'>
        {/* 1ページ目以外はprevPageボタンを表示する */}
        {showPrevPageButton && (
          <li key='arrow_left' className='uc-pagination__item'>
            <Link className='uc-pagination__item-link' to='#' onClick={handleClickPrevButton} data-testid='move_to_left_page'>
              <i className='material-icons'>keyboard_arrow_left</i>
            </Link>
          </li>
        )}
        {visiblePages.map((pageNumber, index, array) =>
          // 現在アクティブなページの判定
          pageNumber === props.currentPageNumber ? (
            <li key={index} className='uc-pagination__item uc-pagination__item--active' aria-current='page'>
              <span className='uc-pagination__item-link'>{pageNumber}</span>
            </li>
          ) : // ピリオド判定(1つ前の配列の要素と現在の要素が連続していない場合、ピリオド表示(...)をする)
          index !== 0 && array[index - 1] + 1 !== pageNumber ? (
            <div key={index} className='uc-pagination__item'>
              <li className='uc-pagination__item'>
                <span className='uc-pagination__item-ellipsis'></span>
              </li>

              <li className='uc-pagination__item'>
                <Link
                  className='uc-pagination__item-link'
                  to='#'
                  onClick={() => props.onSelectPageNumber(pageNumber)}
                  data-testid={`move_to_select_page-${pageNumber}`}
                  data-testid-e2e={`move_to_select_page-${pageNumber}`}>
                  {pageNumber}
                </Link>
              </li>
            </div>
          ) : (
            <li key={index} className='uc-pagination__item'>
              <Link
                className='uc-pagination__item-link'
                to='#'
                onClick={() => props.onSelectPageNumber(pageNumber)}
                data-testid={`move_to_select_page-${pageNumber}`}
                data-testid-e2e={`move_to_select_page-${pageNumber}`}>
                {pageNumber}
              </Link>
            </li>
          )
        )}
        {/* 最終ページ以外はnextPageボタンを表示する */}
        {showNextPageButton && (
          <li key='arrow_right' className='uc-pagination__item'>
            <Link
              className='uc-pagination__item-link'
              to='#'
              onClick={handleClickNextButton}
              data-testid='move_to_right_page'
              data-testid-e2e='Pagination-move-right'>
              <i className='material-icons'>keyboard_arrow_right</i>
            </Link>
          </li>
        )}
      </ul>
    </div>
  );
};
export default PaginationWithoutCache;
